import {
    UPDATE_DOCUMENTOS,
    SET_ARTICULOS, SET_ASIGNAR_IMPORTE,
    SET_CORREO,
    SET_DOCUMENTOS,
    SET_LIMPIAR_FACTURACION,
    SET_SOLO_GENERICO
} from "../actions/otros/facturacionAction";

const initialState = {
    articulos: {
        importe: 0,
        descuento: 0,
        subTotal: 0,
        totalIEPS: 0,
        totalIVA: 0,
        total: 0,
        items: []
    },
    documentos: [],
    soloGenerico: false,
    correo: "",
};

const facturacionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ARTICULOS:
            let artics = initialState.articulos;
            artics.importe = 0;
            artics.descuento = 0;
            artics.subTotal = 0;
            artics.totalIEPS = 0;
            artics.totalIVA = 0;
            artics.total = 0;
            artics.items = [];

            action.payload.forEach((i) => {
                artics.importe = artics.importe + i.ppublico;
                artics.descuento = artics.descuento + i.descuento;
                artics.subTotal = artics.subTotal + i.ppublico - i.descuento;
                artics.totalIEPS = artics.totalIEPS + i.ieps;
                artics.totalIVA = artics.totalIVA + i.iva;
                artics.total = artics.importe + artics.totalIEPS + artics.totalIVA - artics.descuento;
                artics.items.push(i);
            });

            return {
                ...state,
                articulos: artics
            };
        case SET_SOLO_GENERICO:
            return {
                ...state,
                soloGenerico: action.payload
            };
        case SET_DOCUMENTOS:
            return {
                ...state,
                documentos: action.payload
            };
        case UPDATE_DOCUMENTOS:

            console.log("ola");
            console.log(state);
            let x = state.documentos.slice();
            x[action.payload.index].importe = action.payload.value;

            console.log(x);

            return {
                ...state,
                documentos: x.slice()
            };
        case SET_CORREO:
            return {
                ...state,
                correo: action.payload
            };
        case SET_LIMPIAR_FACTURACION:
            return {
                ...state,
                articulos: {}
            };
        case SET_ASIGNAR_IMPORTE:
            return {
                ...state
            };
        default:
            return state;
    }
};

export default facturacionReducer;